import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, CircularProgress, Portal } from '@mui/material';
import { ONLINE_CART_TOKENS } from './style';

export default function StepWrapper({
    children,
    onBack,
    onNext,
    nextLabel = 'Next',
    nextDisabled = false,
    showBack = true,
    showNext = true,
    loading = false,
    maxWidth = ONLINE_CART_TOKENS.contentMaxWidth,
}) {
    return (
        <Box
            sx={{
                minHeight: {
                    // On mobile, allow natural document flow to avoid nested/dual scroll contexts.
                    xs: 'auto',
                    lg: 'calc(100vh - 11rem)',
                },
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                data-online-cart-content
                sx={{
                    maxWidth,
                    width: '100%',
                    mx: 'auto',
                    px: { xs: 2, sm: 3 },
                    py: { xs: 3, lg: 5 },
                    pb: {
                        xs: 'calc(88px + env(safe-area-inset-bottom, 0px) + 2px)',
                        lg: 5,
                    },
                    flex: 1,
                }}
            >
                {children}
            </Box>

            <Portal>
                <Box
                    sx={{
                        display: { xs: 'block', lg: 'none' },
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1200,
                        borderTop: `1px solid ${ONLINE_CART_TOKENS.borderLight}`,
                        backgroundColor: ONLINE_CART_TOKENS.surface,
                        fontFamily: ONLINE_CART_TOKENS.fontFamily,
                        px: 2,
                        pt: 1.25,
                        pb: 'calc(12px + env(safe-area-inset-bottom, 0px))',
                        boxShadow: '0 -2px 12px rgba(16, 24, 40, 0.04)',
                    }}
                >
                    <Box sx={{ maxWidth, width: '100%', mx: 'auto', display: 'flex', alignItems: 'center', gap: 1.25 }}>
                        {showBack && (
                            <Button
                                variant="outlined"
                                color="inherit"
                                onClick={onBack}
                                startIcon={<ArrowBackIcon />}
                                sx={{
                                    height: 48,
                                    minWidth: 96,
                                    borderColor: ONLINE_CART_TOKENS.borderMuted,
                                    color: ONLINE_CART_TOKENS.textMutedSoft,
                                    fontWeight: 600,
                                    fontSize: '0.95rem',
                                    textTransform: 'none',
                                }}
                            >
                                Back
                            </Button>
                        )}
                        {showNext ? (
                            <Button
                                variant="contained"
                                onClick={onNext}
                                disabled={nextDisabled || loading}
                                sx={{
                                    flex: 1,
                                    height: 48,
                                    borderRadius: 2,
                                    backgroundColor: ONLINE_CART_TOKENS.primary,
                                    fontWeight: 700,
                                    fontSize: '1rem',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        backgroundColor: ONLINE_CART_TOKENS.primaryHover,
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                {/* {loading ? 'Processing...' : nextLabel} */}
                                {nextLabel} {loading && <CircularProgress size={16} sx={{color: '#fff', ml: 1}}/>}
                            </Button>
                        ) : null}
                    </Box>
                </Box>
            </Portal>

            <Box
                sx={{
                    display: { xs: 'none', lg: 'block' },
                    maxWidth,
                    width: '100%',
                    mx: 'auto',
                    px: 3,
                    pb: 5,
                    '@media (pointer: coarse) and (orientation: landscape)': {
                        mb: '4rem',
                        '@supports (height: 100dvh)': {
                            mb: '0rem',
                        },
                    },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {showBack ? (
                        <Button
                            variant="text"
                            onClick={onBack}
                            startIcon={<ArrowBackIcon />}
                            sx={{
                                color: ONLINE_CART_TOKENS.textMutedSoft,
                                fontWeight: 700,
                                fontSize: '1rem',
                                textTransform: 'none',
                            }}
                        >
                            Back
                        </Button>
                    ) : (
                        <Box />
                    )}

                    {showNext ? (
                        <Button
                            variant="contained"
                            onClick={onNext}
                            disabled={nextDisabled || loading}
                            sx={{
                                height: 52,
                                px: 5,
                                borderRadius: 2,
                                backgroundColor: ONLINE_CART_TOKENS.primary,
                                fontWeight: 700,
                                fontSize: '1rem',
                                textTransform: 'none',
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: ONLINE_CART_TOKENS.primaryHover,
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            {/* {loading ? 'Processing...' : nextLabel} */}
                            {nextLabel} {loading && <CircularProgress size={16} sx={{color: '#fff', ml: 1}}/>}
                        </Button>
                    ) : null}
                </Box>
            </Box>
        </Box>
    );
}
